// As Seen As Slider
var seenslider = new Swiper(".seenslider", {
  loop: true,
  navigation: {
    nextEl: ".seenslider-next",
    prevEl: ".seenslider-prev",
  },
  slidesPerView: 1,
  paginationClickable: true,
  spaceBetween: 14,
  pagination: {
    el: ".seenslider-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 4000,
  },
  breakpoints: {
    1024: {
      slidesPerView: 5,
    },
    768: {
      slidesPerView: 3,
    },
    0: {
      slidesPerView: 1.8,
    },
  },
});

var blogslider = new Swiper(".video-slider", {
  loop: false,
  navigation: {
    nextEl: ".video-next",
    prevEl: ".video-prev",
  },
  slidesPerView: 1,
  spaceBetween: 12,
  scrollbar: {
    el: ".video-scroll",
    draggable: true,
  },

  breakpoints: {
    1024: {
      slidesPerView: 5,
    },
    600: {
      slidesPerView: 3,
    },
    0: {
      slidesPerView: 2.5,
    },
  },
});

// Hide Main Element if Child Element Is Hidden
var childElement = document.querySelector(
  ".slider_controls > .swiper-button-disabled"
);
if (childElement) {
  var childElementStyle = window.getComputedStyle(childElement);
  if (childElementStyle.display === "none") {
    var parentElement = childElement.parentElement;
    parentElement.style.display = "none";
  }
}

// benefit-slider
var benefit_slider = new Swiper(".benefit-slider", {
  loop: true,
  slidesPerView: 1,
  paginationClickable: true,
  spaceBetween: 0,
  slideToClickedSlide: true,
  navigation: {
    nextEl: ".benefit-button-next",
    prevEl: ".benefit-button-prev",
  },
  breakpoints: {
    1200: {
      slidesPerView: 6,
    },
    1100: {
      slidesPerView: 5,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    600: {
      spaceBetween: 17,
      slidesPerView: 2,
    },
    0: {
      spaceBetween: 17,
      slidesPerView: 1.5,
    },
  },
});

const swiperSlides = document.getElementsByClassName("swiper-slide");

benefit_slider.on("slideChange", function () {
  const otherSlides = swiperSlides;
  for (let index = 0; index < swiperSlides.length; index++) {
    const element = swiperSlides[index];
  }
});

// Blog Slider
var blogslider = new Swiper(".blogslider", {
  loop: false,
  slidesPerView: 1,
  paginationClickable: true,
  spaceBetween: 22,
  navigation: {
    nextEl: ".blogslider-button-next",
    prevEl: ".blogslider-button-prev",
  },
  scrollbar: {
    el: ".blog-scroll",
    draggable: true,
  },
  breakpoints: {
    1440: {
      slidesPerView: 5,
    },
    1100: {
      slidesPerView: 4,
    },
    767: {
      centeredSlides: true,
      slidesPerView: 3,
      spaceBetween: 10,
    },
    600: {
      spaceBetween: 17,
      slidesPerView: 2,
    },
    0: {
      spaceBetween: 17,
      slidesPerView: 1.2,
    },
  },
});

// After/Before Slider
var beforeafterslider = new Swiper(".beforeafterslider", {
  loop: false,
  slidesPerView: 1,
  paginationClickable: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".beforeafterslider-next",
    prevEl: ".beforeafterslider-prev",
  },
  scrollbar: {
    el: ".beforeafterslider-scroll",
    draggable: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
    },
    600: {
      spaceBetween: 17,
      slidesPerView: 2,
    },
    0: {
      spaceBetween: 17,
      slidesPerView: 1,
    },
  },
});

// Review Slider
var reviewslider = new Swiper(".reviewslider", {
  loop: false,
  navigation: {
    nextEl: ".reviewmob-next",
    prevEl: ".reviewmob-prev",
  },
  slidesPerView: 1,
  spaceBetween: 12,
  scrollbar: {
    el: ".review-scroll",
    draggable: true,
  },

  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
      navigation: {
        nextEl: ".review-next",
        prevEl: ".review-prev",
      },
    },
    600: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  },
});

// Custom Tab JS
document.querySelectorAll(".tab-menus a").forEach(function (tabLink) {
  tabLink.addEventListener("click", function (event) {
    event.preventDefault();
    var target = this.getAttribute("data-id");
    document.querySelectorAll(".tab-menus a").forEach(function (link) {
      link.classList.remove("active");
    });

    this.classList.add("active");

    document.querySelectorAll(".tabblock").forEach(function (tabBox) {
      tabBox.classList.remove("active");
      tabBox.style.display = "none";
    });

    var targetTabBox = document.getElementById(target);
    if (targetTabBox) {
      targetTabBox.classList.add("active");
      targetTabBox.style.display = "block";

      targetTabBox.offsetHeight;

      targetTabBox.classList.add("animate-opacity");
    }
  });
});

/* onload class */
const sectionElement = document.querySelector(".sticky_buttons_row");
if (sectionElement) {
  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;
    const sectionRect = sectionElement.getBoundingClientRect();
    const sectionTop = sectionRect.top + window.scrollY;

    if (scrollTop >= sectionTop) {
      document.querySelector(".sticky_buttons_row").classList.add("stickytop");
    } else {
      document
        .querySelector(".sticky_buttons_row")
        .classList.remove("stickytop");
    }
  });
}

const productBoxes = document.querySelectorAll(".productbox");
window.addEventListener("scroll", () => {
  productBoxes.forEach((productBox) => {
    const scrollTop = window.scrollY;
    const productBoxOffset = productBox.offsetTop - 90;

    if (scrollTop >= productBoxOffset) {
      productBoxes.forEach((otherProductBox) => {
        otherProductBox.classList.remove("active");
      });
      productBox.classList.add("active");
      const activeId = productBox.getAttribute("id");
      var container = document.querySelectorAll(".sticy_container");
      container.forEach(function (element) {
        var links = element.querySelectorAll("a");
        links.forEach(function (link) {
          link.classList.remove("active");
        });
      });
      container.forEach(function (element) {
        var activeLink = element.querySelector(`a[data-id="${activeId}"]`);
        if (activeLink) {
          activeLink.classList.add("active");
        }
      });
    } else {
      productBox.classList.remove("active");
    }
  });
});

document
  .querySelectorAll('a[href^="#"].sitebtn')
  .forEach(function (anchor, index) {
    anchor.addEventListener("click", function (event) {
      event.preventDefault();

      var position = document.querySelector(
        anchor.getAttribute("href")
      ).offsetTop;
      if (index === 0) {
        position = position;
      } else {
        position -= 90;
      }
      document.body.scrollTop = position;
      document.documentElement.scrollTop = position;
    });
  });

const section = document.querySelector("#section-video-slider-sec");
if (section) {
  window.addEventListener("scroll", () => {
    const sectionBottom = section.offsetTop + section.offsetHeight - 70;
    if (window.scrollY >= section.offsetTop) {
      document
        .querySelectorAll(".sticy_container .sitebtn.stickybtn")
        .forEach((element) => {
          element.classList.remove("active");
        });
    }
  });
}

var filter_slider = new Swiper(".filter_slider", {
  loop: false,
  allowTouchMove: true,
  scrollbar: {
    el: ".filter-scroll",
    draggable: true,
  },
  breakpoints: {
    749: {
      slidesPerView: 1,
      loop: false,
      allowTouchMove: false,
    },
    562: {
      slidesPerView: 2,
      loop: false,
      allowTouchMove: true,
    },
    400: {
      slidesPerView: 1.5,
      spaceBetween: 12,
    },
    0: {
      slidesPerView: 1.5,
      spaceBetween: 12,
    },
  },
});

var productlistslider = new Swiper(".productsliderblock", {
  loop: false,
  navigation: {
    nextEl: ".productlistslider-next",
    prevEl: ".productlistslider-prev",
  },
  slidesPerView: 1,
  paginationClickable: true,
  spaceBetween: 14,
  pagination: {
    el: ".productlistslider-pagination",
    clickable: true,
  },
  breakpoints: {
    1199: {
      slidesPerView: 2.3,
    },
    767: {
      slidesPerView: 1.7,
    },
    0: {
      slidesPerView: 1.9,
      spaceBetween: 6,
    },
  },
});

var blogslider = new Swiper(".video-slider", {
  loop: false,
  navigation: {
    nextEl: ".video-next",
    prevEl: ".video-prev",
  },
  slidesPerView: 1,
  spaceBetween: 12,
  scrollbar: {
    el: ".video-scroll",
    draggable: true,
  },

  breakpoints: {
    1024: {
      slidesPerView: 5,
    },
    600: {
      slidesPerView: 3,
    },
    0: {
      slidesPerView: 2.5,
    },
  },
});

//About Us slider
var bestsellerslider = new Swiper(".bestsellerslider", {
  loop: false,
  navigation: {
    nextEl: ".bestsellerslider-next",
    prevEl: ".bestsellerslider-prev",
  },
  slidesPerView: 1,
  paginationClickable: true,
  spaceBetween: 14,
  pagination: {
    el: ".bestsellerslider-pagination",
    clickable: true,
  },
  breakpoints: {
    1199: {
      slidesPerView: 4,
    },
    767: {
      slidesPerView: 3,
    },
    0: {
      slidesPerView: 2,
      spaceBetween: 6,
    },
  },
});



$(document).on("click", '.comparing_popup_trigger', function(e) {
e.preventDefault();   
$('section.compare-sec').addClass('active');  
});
$(document).on("click", '.close_comparison,.close_comparison_bg', function(e) {
e.preventDefault();   
$('section.compare-sec').removeClass('active');  
});